import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { SalesCtaPanel } from "@/components/session/SalesCtaPanel";
import { cn } from "@/lib/utils";

export function BookMeetingPreviewModal({
  open,
  onOpenChange,
  bookingUrl,
  avatarThumbUrl,
  avatarName,
  avatarPosition = "right",
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  bookingUrl: string;
  avatarThumbUrl?: string;
  avatarName?: string;
  avatarPosition?: "left" | "right";
}) {
  const avatarOnLeft = avatarPosition === "left";
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl">
        <DialogHeader>
          <DialogTitle>Book a meeting preview</DialogTitle>
          <DialogDescription>
            Approximate preview — the actual session shows the live avatar video.
          </DialogDescription>
        </DialogHeader>
        <div
          className={cn(
            "flex h-[520px] w-full overflow-hidden rounded-lg border",
            avatarOnLeft && "flex-row-reverse",
          )}
        >
          <div className="relative h-full w-[65%] overflow-hidden bg-accent">
            {avatarThumbUrl ? (
              <img
                src={avatarThumbUrl}
                alt={avatarName ?? ""}
                className="h-full w-full object-cover object-center"
              />
            ) : (
              <div className="flex h-full w-full items-center justify-center">
                <span className="text-xs text-muted-foreground">Avatar preview</span>
              </div>
            )}
          </div>
          <div
            className={cn(
              "h-full w-[35%]",
              avatarOnLeft ? "border-r border-border" : "border-l border-border",
            )}
          >
            <SalesCtaPanel bookingUrl={bookingUrl} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}